/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Deactivate_Confirm_With_ProjectsInputs */



/**
* | output |
* | --- |
* | "This space is linked to {count} project(s). They will not use this space for answers while paused. Continue?" |
*
* @param {Spaces_Deactivate_Confirm_With_ProjectsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_deactivate_confirm_with_projects = /** @type {((inputs: Spaces_Deactivate_Confirm_With_ProjectsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Deactivate_Confirm_With_ProjectsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dieser Space ist in ${i?.count} Projekt(en) verlinkt. Diese werden den Space während der Pause nicht für Antworten nutzen. Trotzdem fortfahren?`)
	return /** @type {LocalizedString} */ (`This space is linked to ${i?.count} project(s). They will not use this space for answers while paused. Continue?`)
});